module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g3uMO"))).then(() => parcelRequire('d0iPb'));